import { Injectable } from '@angular/core';
import {
  FormBase,
  TextBox,
  Select
} from '@mapfre-design-library/src/public_api'; 

@Injectable({
  providedIn: 'root'
})
export class SelfRequestFormService {


  getInputs(requestType) : any[]{
    if(requestType === "Other request"){
      return this.inputsOtherRequest();
    }
    if(requestType === "Other request commercial"){
      return this.inputsOtherRequestCommerial();
    }
    if(requestType === "Cancellations"){
      return this.inputsCancellationRequest();
    }

    if(requestType === "initiate"){
      return this.getInitiateRefundInputs();
    }

    if(requestType === "Reissue refund"){
      return this.getReissueRefundInputs();
    }
    
    return [];
  }

  getReissueRefundInputs(){
    const inputs: FormBase<any>[] = [
      new Select({
        additionalClasses: 'form-control',
        inputType: 'select',
        key: 'reissue_refund_topic',
        label: 'SELECT_REASON',
        required: true,
        options: [
          "Unable to cash (expired check)",
          "Received uncashed refund letter",
          "New payee",
          "Lost check"
        ],
        value: "",
        type: 'select',
      })
    ];

    return inputs;
  }

  getInitiateRefundInputs(){
    const inputs: FormBase<any>[] = [
      new Select({
        additionalClasses: 'form-control',
        inputType: 'select',
        key: 'initiate_refund_topic',
        label: 'SELECT_TOPIC',
        required: true,
        options: [
          "Reissue my refund",
          "Question about my refund"
        ],
        value: "",
        type: 'select',
      })
    ];

    return inputs;
  }

  inputsOtherRequest(){
    const inputs: FormBase<any>[] = [
      new Select({
        additionalClasses: 'form-control',
        inputType: 'select',
        key: 'otherRequest_topic',
        label: 'SELECT_TOPIC',
        required: true,
        options: [
          "Question about my bill",
          "Autopay question",
          "Non Pay cancellation question",
          "Paperless question",
          "Premium question",
          "General billing question",
          "Cancellations",
          "Issues with online account"
        ],         
        value: "",
        type: 'select',
      }),
      this.getAdditionalInfoTextBox(true),
    ];

    return inputs;
  }
  getOtherRequestTopicMAGWLists(){
    return [
      {
        id: 1,
        name: 'Select one',
        disabled: true,
      },
      {
        id: 2,
        name: 'Question about my bill',
        disabled: false,
      },
      {
        id: 3,
        name: 'Autopay question',
        disabled: false,
      },
      {
        id: 4,
        name: 'Non Pay cancellation question',
        disabled: false,
      },
      {
        id: 5,
        name: 'Paperless question',
        disabled: false,
      },
      {
        id: 6,
        name: 'Premium question',
        disabled: false,
      },
      {
        id: 7,
        name: 'General billing question',
        disabled: false,
      },
      {
        id: 8,
        name: 'Cancellations',
        disabled: false,
      },
      {
        id: 9,
        name: 'Issues with online account',
        disabled: false,
      },
  ]
  }
  getOtherRequestTopicNonMAGwLists(){
    return [
      {
        id: 1,
        name: 'Select one',
        disabled: true,
      },
      {
        id: 2,
        name: 'Question about my bill',
        disabled: false,
      },
      {
        id: 3,
        name: 'Autopay question',
        disabled: false,
      },
      {
        id: 4,
        name: 'Non Pay cancellation question',
        disabled: false,
      },
      {
        id: 5,
        name: 'Paperless question',
        disabled: false,
      },
      {
        id: 6,
        name: 'Premium question',
        disabled: false,
      },
      {
        id: 7,
        name: 'General billing question',
        disabled: false,
      },
      {
        id: 8,
        name: 'Issues with online account',
        disabled: false,
      },
  ]
  }
  getCancellationsRequestTopicLists() {
    return [
      {
        id: 1,
        name: 'Select one',
        disabled: true,
      },
      {
        id: 2,
        name: 'License plate cancellation',
        disabled: false,
      },
      {
        id: 3,
        name: 'New insurance coverage',
        disabled: false,
      },
    ]
  }

  inputsCancellationRequest(){
    const inputs: FormBase<any>[] = [
      new Select({
        additionalClasses: 'form-control',
        inputType: 'select',
        key: 'cancellation_topic',
        label: 'SELECT_CANCEL_REASON',
        required: true,
        options: [
          "License plate cancellation",
          "New insurance coverage"
        ],
        value: "",
        type: 'select',
      }),
      this.getAdditionalInfoTextBox(false),
    ];

    return inputs;
  }

  getAdditionalInfoTextBox(isRequired: boolean): TextBox{
    return new TextBox({
      additionalClasses: 'form-control',
      inputType: 'text',
      key: 'addInfo',
      label: isRequired ? 'ADD_ADDITIONAL_INFO_REQUIRED' : 'ADD_ADDITIONAL_INFO',
      required: isRequired,
      type: 'text',
    })
  }
  inputsOtherRequestCommerial(){
    const inputs: FormBase<any>[] = [
      new Select({
        additionalClasses: 'form-control',
        inputType: 'select',
        key: 'otherRequest_topic',
        label: 'SELECT_TOPIC',
        required: true,
        options: [
          "Question about my bill",
          "Autopay question",
          "Non Pay cancellation question",
          "Paperless question",
          "Premium question",
          "General billing question",
          "Issues with online account"
        ],
        value: "",
        type: 'select',
      }),
      this.getAdditionalInfoTextBox(true),
    ];
    return inputs;
  }

}
